import { createContext } from 'react';
import { WorkbenchLocaleContextType } from './types';

export const WorkbenchLocaleContext = createContext<WorkbenchLocaleContextType>({
  workbenchLocale: undefined,
});
